import AbstractDelay from "./AbstractDelay";

class Interval extends AbstractDelay {
    protected clearMethod: (id: number) => void = clearInterval;
    protected setMethod: (callback: () => void, delay: number) => number = setInterval;
}

export const Intervals = new Interval();